import Parse from "parse";

type OD3_Tenant = Parse.Object;
type _User = Parse.Object;

export interface AnalyticsShareAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  tenant: OD3_Tenant;
  passwordHash: string;
  label?: string;
  createdBy?: _User;
  lastAccessAt?: Date;
}

export class AnalyticsShare extends Parse.Object<AnalyticsShareAttributes> {
  constructor(data?: Partial<AnalyticsShareAttributes>) {
    super("APP_AnalyticsShare", data as AnalyticsShareAttributes);
  }
}

Parse.Object.registerSubclass("APP_AnalyticsShare", AnalyticsShare);
